angular.module("informations")

    .controller("InformationsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', 'logService', '$translate', 'modalService', '$uibModal','Upload',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, logService, $translate, modalService, $uibModal, Upload) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("INFORMATION_WRITE");

            $scope.information = {
                information_type_id: "",
                date: new Date()
            };

            Restangular.all('Events/AllEvents').getList(options).then(function (events) {
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('informations.no_event')
                });
            });

            $scope.downloadUrl = undefined;

            $scope.event = $stateParams.id;

            if (angular.isDefined($scope.event) && $scope.event != "") $scope.information.event_id = parseInt($stateParams.id);
            $scope.currentState = $state.current.name;            

            if (angular.isUndefined($stateParams.information_id) || $stateParams.information_id == "") {
                if ($scope.currentState == 'informations.edit') {
                    $rootScope.breadcrumb = [
                  {
                      title: $filter('translate')('events.informations'),
                      url: "informations.list"
                  },
                  {
                      title: $filter('translate')('informations.title_add')
                  }
                    ];
                    $rootScope.title = $filter('translate')('events.informations');
                } else {
                    Restangular.one('Events', $stateParams.id).get().then(function (results) {
                        $rootScope.breadcrumb = [
                       { title: $filter('translate')('events.title'), url: "events.list" },
                       { title: results.name, url: "events.edit({ id: " + $stateParams.id + " })" },
                       { title: $filter('translate')('events.informations'), url: "events.edit.informations({ id:" + $scope.event + " })" },
                       { title: $filter('translate')('informations.title_add') }
                        ];
                        $rootScope.title = results.name + " - " + $filter('translate')('events.informations');
                    });
                }

            } else {                

                $scope.id = $stateParams.information_id;
                
                Restangular.one('Informations', $stateParams.information_id).get().then(function (information) {
                    if ($scope.currentState == 'informations.edit') {
                        $rootScope.breadcrumb = [
                         { title: $filter('translate')('informations.title'), url: "informations.list" },
                         { title: $filter('translate')('informations.title_edit') },
                        ];

                        $rootScope.title = $filter('translate')('informations.title');
                    } else {
                        Restangular.one('Events', $stateParams.id).get().then(function (results) {
                            $rootScope.breadcrumb = [
                           { title: $filter('translate')('events.title'), url: "events.list" },
                           { title: results.name, url: "events.edit({ id: " + $stateParams.id + " })" },
                           { title: $filter('translate')('informations.title'), url: "events.edit.informations({ id: " + $scope.event + " })" },
                           { title: $filter('translate')('informations.title_edit') }
                            ];
                            $rootScope.title = results.name + " - " + $filter('translate')('informations.title');
                        });
                    }
                    $scope.information = information;
                    $scope.information.date = new Date($scope.information.date);
                    $scope.downloadUrl = (window as any).CONFIG.api_url + 'Informations/getFile?id=' + $scope.information.id + '&filename=' + $scope.information.file_name
                });
            }

            Restangular.all('InformationsTypes').getList().then(function (types) {
                $scope.selectTypes = types;
            });

            var options = {
                searchName: "",
                is_template: false
            };

            $scope.onSelectFile = function (event) {
                if (event.target.files && event.target.files[0]) {
                    var reader = new FileReader();

                    reader.readAsDataURL(event.target.files[0]); // read file as data url

                    reader.onload = (event) => { // called once readAsDataURL is completed
                        $scope.downloadUrl = event.target.result;
                    }
                }
            }

            $scope.uploadFile = function (id) {
                $scope.showProgressBar = true;
                $scope.file.upload = Upload.upload({
                    url: (window as any).CONFIG.api_url + "Informations/uploadFile",
                    data: { file: $scope.file, name: id }
                });

                $scope.file.upload.then(function (response) {
                    toastr.success($filter('translate')('informations.save_success'));
                    if ($scope.currentState == 'informations.edit') {
                        $state.go("informations.list");
                    } else {
                        $state.go("events.edit.informations", { id: $scope.event });
                    }
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    // Math.min is to fix IE which reports 200% sometimes
                    //$scope.file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)); // Ralentiza MUCHO la subida
                });
            };

            $scope.regExp = new RegExp("(image/*)|(audio/*)|(video/*)");

            $scope.regExpImage = new RegExp("(image/*)");
            $scope.regExpVideo = new RegExp("(video/*)");
            $scope.regExpAudio = new RegExp("(audio/*)");

            $scope.downloadFile = function () {
                window.open((window as any).CONFIG.api_url + 'Informations/getFile?id=' + $scope.information.id + '&filename=' + $scope.information.file_name, '_blank', '');
            };


            $scope.$watch('file', function (newValue, oldValue) {
                if (newValue !== null && typeof (newValue) !== "undefined") {
                    $scope.information.file_name = newValue.name;
                    $scope.information.mimetype = newValue.type === "" || newValue.type === null || !angular.isDefined(newValue.type) ? "application/octet-stream" : newValue.type;
                    $scope['file'] = newValue;
                }else
                    $scope['file'] = oldValue;
            });

            $scope.saveInformation = function () {
                if (angular.isUndefined($stateParams.information_id) || $stateParams.information_id === "") {
                    Restangular.all('Informations').post($scope.information).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            $scope.uploadFile(result.id);
                        }
                    });
                } else {
                    $scope.information.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            if (angular.isDefined($scope.file) && $scope.file !== null) //guardo imagen solo si ha cambiado
                                $scope.uploadFile(result.id);
                            else {
                                toastr.success($filter('translate')('informations.edit_success'));
                                if ($scope.currentState === 'informations.edit') {
                                    $state.go("informations.list");
                                } else {
                                    $state.go("events.edit.informations", { id: $scope.event });
                                }
                            }
                        }
                    });
                }
            };

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('informations.button_delete'),
                    message: $filter('translate')('informations.delete_message') + " " + $scope.information.name + "?",
                    onAccept: function () {
                        $scope.information.remove().then(function () {
                            toastr.success($filter('translate')('informations.delete_success'));
                            if ($scope.currentState === 'informations.edit') {
                                $state.go("informations.list");
                            } else {
                                $state.go("events.edit.informations", { id: $scope.event });
                            }
                        });
                    }
                });
            };

        }])
;

